import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    espaco,
    fimLinha,
    obtemDadoPDF,
    indexAtualJsonRegistros,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
} from './IntegracaoClienteArquivoService'



export const importaConsorcioAdemicon = (PDFTxt, vars, linhaIntegracao, seguradora, nomeArquivo, erros, tipoConsorcio) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Nome / Empresa' + fimLinha, fimLinha,
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Data Nasc./Fundação' + fimLinha + espaco, fimLinha, 
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'CPF/CNPJ' + fimLinha, fimLinha,
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Sexo' + fimLinha + espaco, fimLinha,
        HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Endereço Residencial' + fimLinha, fimLinha,
        HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Número' + fimLinha, fimLinha,
        HARDCODE.importacaoNumeroEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Bairro' + fimLinha, fimLinha,
        HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Cidade' + fimLinha, fimLinha,
        HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Estado' + fimLinha + espaco, fimLinha,
        HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Telefone  Telefone Celular' + fimLinha, fimLinha,
        HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'E-mail' + fimLinha, fimLinha,
        HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)
        
    //obtemDadoPDF(PDFTxt, jsonRegistros, espaco, espaco,
    //    HARDCODE.importacaoPessoaFisicaJuridica, true, null, erros, nomeArquivo)
    if (PDFTxt.indexOf('F(X)') !== -1) {

        jsonRegistros.jsonRegistros[indexJsonRegistros].pessoaFisicaJuridica = HARDCODE.idPessoaFisica

    } else {

        jsonRegistros.jsonRegistros[indexJsonRegistros].pessoaFisicaJuridica = HARDCODE.idPessoaJuridica
    }

    obtemDadoPDF(PDFTxt, jsonRegistros,
        fimLinha + espaco + 'Empresa onde trabalha (P.F.)  Renda Média Mensal (P.F.).Faturamento (P.J.) em R$' + fimLinha,
            fimLinha, HARDCODE.importacaoRendaMensal, true, null, erros, nomeArquivo)
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'CEP' + fimLinha, fimLinha, 
        HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Grupo' + fimLinha, fimLinha,
        HARDCODE.importacaoGrupoConsorcio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Cota' + fimLinha, fimLinha,
        HARDCODE.importacaoCotaConsorcio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Prazo Grupo' + fimLinha, fimLinha,
        HARDCODE.importacaoPrazoTotalGrupoConsorcio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Prazo Cota' + fimLinha, fimLinha,
        HARDCODE.importacaoPrazoTotalCotaConsorcio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'Nº Participantes' + fimLinha, fimLinha,
        HARDCODE.importacaoNumeroTotalParticipantesGrupoConsorcio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros,
        fimLinha + espaco + 'Valor do Crédito na Data' + fimLinha + espaco + 'da Adesão' + fimLinha, fimLinha,
            HARDCODE.importacaoValorCreditoConsorcio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + '% Fundo de Reserva:' + fimLinha, fimLinha,
        HARDCODE.importacaoPercFundoReserva, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + '% Taxa de Administração Total:' + fimLinha, fimLinha,
        HARDCODE.importacaoTaxaAdministracaoTotal, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + '% Mensal de Seguro' + fimLinha, fimLinha,
        HARDCODE.importacaoPercSeguroPrestamista, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + espaco + 'CONTRATO:' + espaco, espaco,
        HARDCODE.importacaoNumeroConsorcio, true, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].tipoConsorcio = tipoConsorcio

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + '4. DADOS DO GRUPO' + fimLinha, fimLinha,
    //    HARDCODE.importacaoStatusGrupoConsorcio, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'PARCELA INICIAL FORMA DE PAGAMENTO' + fimLinha, fimLinha,
    //    HARDCODE.importacaoTipoFormaPagtoConsorcio, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'POR E-MAIL' + fimLinha, espaco,
    //    HARDCODE.importacaoDataAssembleia, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, espaco, fimLinha,
    //    HARDCODE.importacaoNumeroAssembleiaParticipacao, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha,
    //    HARDCODE.importacaoValorParcelaInicial, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'LANCE EMBUTIDO LANCE FIXO' + fimLinha, '%',
    //    HARDCODE.importacaoPercLanceEmbutido, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, espaco, '%', HARDCODE.importacaoPercLanceFixo, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + '(+) Outros Acréscimos' + fimLinha, fimLinha,
    //    HARDCODE.importacaoDataVenctoBoleto, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Profissão / ocupação profissional' + fimLinha, fimLinha,
    //    HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
    


    return jsonRegistros.jsonRegistros
}

export const importaConsorcioBensImoveisAdemicon = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao,
    seguradora, nomeArquivo, erros, variaveisGlobais) => {

    return importaConsorcioAdemicon(PDFTxt, vars, linhaIntegracao, seguradora, nomeArquivo, erros,
        HARDCODE.idTipoConsorcioBensImoveis)
}